export const AIRT_SCANS_KEY = "scan";
export const DDOS_FILTER_KEY = "ddos";
export const DNS_FIREWALL_KEY = "dns-firewall";
